import moment, { Moment } from 'moment/moment'
import { TagSection, TagSectionPayload } from '@/core/models/tag-section'
import { Stroke, StrokePayload } from '@/core/models/stroke'

export interface TagPayload {
    id: number
    tag_section_id: number
    slug: string
    published?: boolean
    sort_order: number
    created_at: string
    section?: TagSectionPayload
    stroke?: StrokePayload
    translations?: {}
}

export class Tag {

    id: number
    tagSectionId: number
    slug: string
    published: boolean
    sortOrder: number
    createdAt: Moment
    section: TagSection
    stroke: Stroke
    translations?: {} = <any>{}

    constructor(data: TagPayload) {
        this.id = data.id
        this.tagSectionId = data.tag_section_id
        this.slug = data.slug
        this.published = !! data.published
        this.sortOrder = data.sort_order
        this.createdAt = moment(data.created_at)
        this.section = new TagSection(data.section || <any>{})
        this.capture(data)
    }

    fill(data: TagPayload): this {
        this.id = data.id
        this.tagSectionId = data.tag_section_id
        this.slug = data.slug
        this.published = !! data.published
        this.sortOrder = data.sort_order
        this.createdAt = moment(data.created_at)
        this.section = new TagSection(data.section || <any>{})
        this.capture(data)
        return this
    }

    capture(data: TagPayload): this {
        if (data.translations) {
            this.translations = data.translations
        }
        return this
    }

    exists(): boolean {
        return !! this.id
    }

    unset(): void {
        this.fill(<any>{})
        this.translations = {}
    }

    payload(): TagPayload | any {
        return {
            id: this.id,
            tag_section_id: this.tagSectionId,
            slug: this.slug,
            published: this.published,
            sort_order: this.sortOrder,
            translations: this.translations,
        }
    }
}
